import { ReactNode, useEffect, useState } from "react";

import AppNavbar from "@/components/common/AppNavbar";
import Shimmer from "@/components/common/Shimmer";
import AboutHareengSection from "@/components/Homepage/About";
import ScooterSection from "@/components/Homepage/Explore";
import EarnWithHareeng from "@/components/Homepage/Features";
import Footer from "@/components/Homepage/Footer";
import Hero from "@/components/Homepage/Hero";
import OpportunitiesSlider from "@/components/Homepage/Partners";
import SafetySection from "@/components/Homepage/Safety";
import UpdatesSection from "@/components/Homepage/Updates";

interface MasterLayoutProps {
  children?: ReactNode;
  loading?: boolean;
}

export default function MasterLayout({
  children,
  loading = false,
}: MasterLayoutProps = {}) {
  // Individual loading states for each section (simulate async loading)
  const [heroLoading, setHeroLoading] = useState(true);
  const [sliderLoading, setSliderLoading] = useState(true);
  const [earnLoading, setEarnLoading] = useState(true);
  const [safetyLoading, setSafetyLoading] = useState(true);
  const [scooterLoading, setScooterLoading] = useState(true);
  const [aboutLoading, setAboutLoading] = useState(true);
  const [downloadLoading, setDownloadLoading] = useState(true);
  const [updatesLoading, setUpdatesLoading] = useState(true);

  useEffect(() => {
    // Simulate async loading for each section
    const timers = [
      setTimeout(() => setHeroLoading(false), 300),
      setTimeout(() => setSliderLoading(false), 400),
      setTimeout(() => setEarnLoading(false), 500),
      setTimeout(() => setSafetyLoading(false), 600),
      setTimeout(() => setScooterLoading(false), 700),
      setTimeout(() => setAboutLoading(false), 800),
      setTimeout(() => setDownloadLoading(false), 900),
      setTimeout(() => setUpdatesLoading(false), 1000),
    ];
    return () => timers.forEach(clearTimeout);
  }, []);

  return (
    <div className="min-h-screen overflow-x-hidden bg-base-100">
      <AppNavbar transparent />
      {loading ? (
        <Shimmer />
      ) : (
        <>
          {heroLoading ? <Shimmer /> : <Hero />}
          {earnLoading ? <Shimmer /> : <EarnWithHareeng />}
          {sliderLoading ? <Shimmer /> : <OpportunitiesSlider />}
          {safetyLoading ? <Shimmer /> : <SafetySection />}
          {scooterLoading ? <Shimmer /> : <ScooterSection />}
          {aboutLoading ? <Shimmer /> : <AboutHareengSection />}
          {updatesLoading ? <Shimmer /> : <UpdatesSection />}
          <Footer />
        </>
      )}
    </div>
  );
}
